<mat-toolbar>
    <button mat-icon-button class="example-icon" aria-label="Example icon-button with menu icon">
    <mat-icon>menu</mat-icon>
  </button>
    <!-- <span>DeFi-PoLy</span> -->
    <img src="assets/logo_1.png" height="60">
    <span class="example-spacer"></span>
    <button mat-icon-button class="toolbar-button favorite-icon" aria-label="Example icon-button with heart icon" [matMenuTriggerFor]="menuEth">
    <mat-icon *ngIf="network?.chainId != 80001" svgIcon="ethereum-eth-logo"></mat-icon>
    <mat-icon *ngIf="network?.chainId == 80001" svgIcon="matic-logo"></mat-icon>
    <span>{{ethAccount}}</span>
  </button>
    <mat-menu #menuEth="matMenu" xPosition="before">
        <div class="mat-toolbar">
            <div>{{network?.symbol}} balance: {{balanceEth}}</div>
            <div>USDc balance: {{balanceUSDc}}</div>
            <button mat-raised-button (click)="logout()" [disabled]="network == undefined">Logout</button>
            <!-- <button mat-menu-item>Expand</button>
        <button mat-menu-item>Remove</button> -->
        </div>
    </mat-menu>
    <button mat-icon-button class="toolbar-button favorite-icon">
        <img src="assets/blockchain.png" height="24" style="top: 4px; position:relative;">
        <span>{{network?.name}}</span>
    </button>
    <button mat-icon-button class="toolbar-button favorite-icon" aria-label="Example icon-button with share icon" [matMenuTriggerFor]="menuDiscord">
    <img src="https://discord.com/assets/1c8a54f25d101bdc607cec7228247a9a.svg" height="30">
    <span>{{discordUsername}}</span>
  </button>
    <mat-menu #menuDiscord="matMenu" xPosition="before">
        <div class="mat-toolbar">
            <button mat-raised-button (click)="connectDiscord()" target="_blank">Connect</button>
            <!-- <button mat-menu-item>Expand</button>
    <button mat-menu-item>Remove</button> -->
        </div>
    </mat-menu>
    <button mat-icon-button class="toolbar-button favorite-icon" aria-label="Example icon-button with share icon">
      <mat-icon>account_circle</mat-icon>
      <span>{{username}}</span>
    </button>
</mat-toolbar>